// extracted by mini-css-extract-plugin
export default {"dateBadge":"DateBadge_dateBadge__BRbdK","dayAbbrev":"DateBadge_dayAbbrev__gzNrm","dayNumber":"DateBadge_dayNumber__gbgrM","monthYear":"DateBadge_monthYear__WEXO0"};